var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-form',{attrs:{"value":_vm.value,"title":_vm.$localize('DeleteVacation.title'),"allow-continue":false},on:{"input":function($event){return _vm.$emit('input', $event)},"commit":_vm.save,"reset":function($event){_vm.addVacation = {}}}},[_c('p',[_vm._v(_vm._s(_vm.$localize("DeleteVacation.description")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }